(function () {
    "use strict";

    angular
        .module("app")
        .directive("hierarchyCodeTypeAhead", ["PatternService", hierarchyCodeTypeAhead]);

    function hierarchyCodeTypeAhead(patternService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return patternService.getHierarchyCodes(searchText).then(function (response) {
                        if (response) {
                            angular.forEach(response, function (item) {
                                item.DisplayText = item.HierarchyCodeDesc + " (" + item.HierarchyCodeKey + ")";
                            });
                            return response;
                        }
                        return [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.HierarchyCodeKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "="},
            template: '<input' +
                ' uib-typeahead="item.DisplayText for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();

